import { Box, Card, CardContent, CardHeader, Skeleton, Stack, Typography } from '@mui/material'
import { observer, useLocalStore } from 'mobx-react-lite'
import { useTranslate } from 'GlobalStores/Cores/Translator/useTranslate'
import MonthSelector from '../Achievements/Elements/MonthSelector'
import CenturionProgressBar from './CenturionProgressBar'
import CenturionTable from './CenturionTable'
import { useEffect } from 'react'
import { autorun, reaction } from 'mobx'
import StoreAchievement from '../Achievements/StoreAchievement'
import { get } from 'lodash'

const CenturionSkeleton = () => {
    return (
        <Stack direction={'column'} gap="20px">
            {/* MonthSelector Skeleton */}
            <Stack direction={'row'} gap="24px" justifyContent={'center'}>
                <Skeleton variant="text" width={40} height={24} />
                <Skeleton variant="text" width={40} height={24} />
                <Skeleton variant="text" width={40} height={24} />
            </Stack>

            {/* Progress Bar Skeleton */}
            <Stack paddingX="20px" paddingTop="10px">
                <Stack sx={{ width: '100%', position: 'relative', paddingTop: '30px', paddingBottom: '10px' }}>
                    {/* Value Bubble Skeleton */}
                    <Box sx={{ position: 'absolute', left: '10%', top: '-8px', transform: 'translateX(-50%)' }}>
                        <Skeleton variant="rounded" width={50} height={28} sx={{ borderRadius: '20px' }} />
                    </Box>

                    {/* Progress Bar Skeleton */}
                    <Skeleton variant="rounded" width={'100%'} height={16} sx={{ borderRadius: '10px' }} />

                    {/* Ticks Skeleton */}
                    <Stack direction={'row'} justifyContent={'space-between'} sx={{ marginTop: '16px' }}>
                        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(tick => (
                            <Skeleton key={tick} variant="text" width={20} height={20} />
                        ))}
                    </Stack>
                </Stack>
            </Stack>

            {/* Table Skeleton */}
            <Stack>
                {/* Table Header */}
                <Stack direction={'row'} gap="8px" sx={{ backgroundColor: 'rgba(227, 232, 237, 1)', borderRadius: '6px', padding: '12px' }}>
                    <Skeleton variant="text" width={'40%'} height={20} />
                    <Skeleton variant="text" width={'30%'} height={20} />
                    <Skeleton variant="text" width={'30%'} height={20} />
                </Stack>
                {/* Table Rows */}
                {[1, 2, 3, 4, 5].map(row => (
                    <Stack
                        key={row}
                        direction={'row'}
                        gap="8px"
                        sx={{
                            padding: '12px',
                            backgroundColor: row % 2 === 0 ? 'rgba(245, 245, 245, 1)' : 'rgba(255, 255, 255, 1)'
                        }}>
                        <Skeleton variant="text" width={'40%'} height={18} />
                        <Skeleton variant="text" width={'30%'} height={18} />
                        <Skeleton variant="rounded" width={20} height={20} sx={{ marginLeft: 'auto' }} />
                    </Stack>
                ))}
            </Stack>
        </Stack>
    )
}

const Centurion = observer(() => {
    const translate = useTranslate()
    const isLoading = StoreAchievement.getAchievements().length === 0 || StoreAchievement.getIsLoadingCenturion()

    const localObserver = useLocalStore(() => ({
        centurionCount: 0,
        totalCenturionCustomers: 0
    }))

    useEffect(() => {
        // const disposer = reaction(
        //     () => StoreAchievement.getPeriodWithMonthDigit(),
        //     n => {
        //         const items = StoreAchievement.getCenturions(n)?.[0]
                
        //         if (items) {
        //             localObserver.totalCenturionCustomers = 0
        //             localObserver.centurionCount = items.value[0]?.metrics.find(metric => metric.name === 'centurionCount')?.value || 0
        //             items.metricsDetails?.count.customers.forEach(item => {
        //                 console.log('item', item)
        //                 if (get(item.customer, 'centurionCount.value', 0) === 0) return null
        //                 localObserver.totalCenturionCustomers++
        //             })
        //         }
        //     }
        // )

        // return () => {
        //     disposer()
        // }

        const disposer = autorun(() => {
            if (StoreAchievement.getPeriodWithMonthDigit() && StoreAchievement.getCenturions(StoreAchievement.getPeriodWithMonthDigit())[0]) {
                const items = StoreAchievement.getCenturions(StoreAchievement.getPeriodWithMonthDigit())?.[0]
                
                if (items) {
                    localObserver.totalCenturionCustomers = 0
                    localObserver.centurionCount = items.value[0]?.metrics.find(metric => metric.name === 'centurionCount')?.value || 0
                }
                items.metricsDetails?.count.customers.forEach(item => {
                 
                    if (get(item.customer, 'centurionCount.value', 0) === 0) return null
                    localObserver.totalCenturionCustomers++
                })
            }
        })

        return () => {
            disposer()
        }
    }, [])

    return (
        <Card sx={{ '&.MuiPaper-root': { borderRadius: '8px' } }} elevation={0}>
            <CardHeader
                title={
                    <Typography variant="h6" color="rgba(56, 66, 80, 1)" fontSize={'18px'} fontWeight={400} textAlign={'center'} lineHeight={'1'}>
                        {translate('centurion')}
                    </Typography>
                }
                sx={{
                    backgroundColor: 'rgba(233, 241, 250, 1)',
                    paddingY: '12px'
                }}
            />
            <CardContent>
                {isLoading ? (
                    <CenturionSkeleton />
                ) : (
                    <Stack direction={'column'} gap="20px">
                        <MonthSelector />
                        <Stack paddingX="20px" paddingTop="10px">
                            <CenturionProgressBar value={localObserver.centurionCount} markers={[30, 60, 100]} />
                        </Stack>
                        {localObserver.totalCenturionCustomers > 0 ? <CenturionTable /> : null}
                    </Stack>
                )}
            </CardContent>
        </Card>
    )
})

export default Centurion
